import { deepFreeze, type DeepReadonly, type Person } from '@tadpoles/common'

export type UserContext = Readonly<{
    person: DeepReadonly<Person>
}>

export function createUserContext(person: DeepReadonly<Person>): UserContext {
    return deepFreeze({
        person: structuredClone(person)
    })
}
